import { useState, useEffect } from "react";
import { Card, Badge } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { ApiHelper } from "../../utils/ApiHelper";
import CompanyProfile from "../../components/Setting/CompanyProfile";
import { useCompanyData } from "../../hooks/useCompanyData";
import { REQUIREMENTS_COUNT_BY_STATUS } from "../../lib/API_KEYS";



const Settings = () => {
  const { company: formData, loading: companyLoading } = useCompanyData();
  const [requirementsCount, setRequirementsCount] = useState({});

  useEffect(() => {
    const fetchRequirementsCount = async () => {
      const res = await new ApiHelper().FetchFromServer(
        ...REQUIREMENTS_COUNT_BY_STATUS,
      );
      const data = Object.fromEntries(res.data?.map((r) => [r._id, r.count]) || [])
      setRequirementsCount(data || null);
    }
    fetchRequirementsCount()
  }, [])

  if (!formData || companyLoading) {
    return <div className="container-fluid profile-page py-4 px-3"><p>Loading...</p></div>;
  }

  return (
    <div className="container-fluid profile-page py-4 px-3">
      <div className="text-center profile-header">
        <img
          src={formData?.profileImage || "/images/profile.svg"}
          className="profile-avatar mb-2"
        />
        <h4 className="fw-bold">{formData?.name}</h4>
        <div className="rating mb-2">
          {Array(5)
            .fill(0)
            .map((_, i) => (
              <FaStar key={i} color="#f5c518" />
            ))}
        </div>
        <p className="text-muted d-flex flex-wrap justify-content-center align-items-center gap-2 text-center">
          <span className="d-flex align-items-center gap-1">
            <img src="/images/company.svg" alt="company" width="18" />
            {formData?.website}
          </span>
          <span className="d-flex align-items-center gap-1">
            <img src="/images/location.svg" alt="location" width="18" />
            {formData?.address}
          </span>
          <span className="d-flex align-items-center gap-1">
            <img src="/images/mail.svg" alt="email" width="18" />
            {formData?.email}
          </span>
        </p>

      </div>

      <div className="row text-center my-4 border py-3 rounded-4 shadow-sm">
        <div className="col-6 col-md-3 border-end">
          <h5 className="fw-bold">{Object.values(requirementsCount).reduce((s, n) => s + n, 0) || 0}</h5>
          <p className="text-muted">Total RFQ</p>
        </div>
        <div className="col-6 col-md-3 border-end">
          <h5 className="fw-bold">{requirementsCount?.['In Review'] || 0}</h5>
          <p className="text-muted">In Review</p>
        </div>
        <div className="col-6 col-md-3 border-end">
          <h5 className="fw-bold">{requirementsCount?.Approved || 0}</h5>
          <p className="text-muted">Approved</p>
        </div>
        <div className="col-6 col-md-3">
          <h5 className="fw-bold">{requirementsCount?.Rejected || 0}</h5>
          <p className="text-muted">Rejected</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Card className="mb-3 shadow-sm border-0 rounded-4">
            <Card.Body>
              <h6 className="fw-bold mb-2">Profile</h6>
              <hr />

              <p className="d-flex align-items-center gap-2">
                <img src="/images/company.svg" alt="company" style={{ width: "20px", height: "20px" }} />
                {formData?.name}
              </p>

              {/* <p className="d-flex align-items-center gap-2">
                <img src="/images/level.svg" alt="level" style={{ width: "20px", height: "20px" }} />
                {formData.email}
              </p> */}

              {/* <p className="d-flex align-items-center gap-2">
                <img src="/images/seller.svg" alt="seller" style={{ width: "20px", height: "20px" }} />
                {formData.website}
              </p> */}

              <p className="d-flex align-items-center gap-2">
                <img src="/images/mail.svg" alt="email" style={{ width: "20px", height: "20px" }} />
                {formData?.email}
              </p>

              <p className="d-flex align-items-center gap-2">
                <img src="/images/web.svg" alt="website" style={{ width: "20px", height: "20px" }} />
                {formData?.website}
              </p>

              {/* <p className="d-flex align-items-center gap-2">
                <img src="/images/socials.svg" alt="social" style={{ width: "20px", height: "20px" }} />
                @electricM3
              </p> */}
            </Card.Body>
          </Card>
        </div>

        <div className="col-md-6">
          <Card className="mb-3 shadow-sm border-0 rounded-4">
            <Card.Body>
              <h6 className="fw-bold mb-2">About me</h6>
              <hr />
              <p className="text-muted">
                I am a results-driven electronics seller with a strong passion
                for technology and innovation. With years of experience in the
                electronics market, I specialize in offering high-quality
                products and solutions tailored to meet diverse customer needs.
              </p>
              {/* <p className="text-muted">
                My focus is on delivering excellent service, building trust, and
                helping clients make informed purchasing decisions.
              </p> */}
            </Card.Body>
          </Card>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-md-6">
          <Card className="mb-3 shadow-sm border-0 rounded-4">
            <Card.Body>
              <h6 className="fw-bold mb-2">Our Team</h6>
              <hr />
              <div className="d-flex align-items-center flex-wrap">
                {[
                  "https://i.pravatar.cc/50?img=11",
                  "https://i.pravatar.cc/50?img=12",
                  "https://i.pravatar.cc/50?img=13",
                  "https://i.pravatar.cc/50?img=14",
                ].map((avatar, i) => (
                  <img
                    key={i}
                    src={avatar}
                    alt="team"
                    className="team-avatar me-2 mb-2"
                  />
                ))}
              </div>
              <hr className="mt-3" />
              <p className="fw-bold text-dark text-center join-text">
                Join Us
              </p>

            </Card.Body>
          </Card>
        </div>

        <div className="col-md-6">
          <Card className="mb-3 shadow-sm border-0 rounded-4">
            <Card.Body>
              <h6 className="fw-bold mb-2">Skills</h6>
              <hr />
              {[
                "Consumer Electronics",
                "Automotive Electronics",
                "Industrial Electronics",
                "Medical Electronics",
                "Telecommunications",
              ].map((skill, i) => (
                <Badge key={i} bg="light" text="dark" className="me-2 mb-2">
                  {skill}
                </Badge>
              ))}
            </Card.Body>
          </Card>
        </div>
      </div> */}

      {/* <div className="row">
        {[
          {
            title: "Urban Dreams",
            img: "https://images.unsplash.com/photo-1541534401786-2077eed87a74?auto=format&fit=crop&w=800&q=80", // Electronics
            author: "Claire Rogers",
            views: 24,
          },
          {
            title: "Timeless Elegance",
            img: "https://images.unsplash.com/photo-1593642532973-d31b6557fa68?auto=format&fit=crop&w=800&q=80", // Tech / Laptop
            author: "Claire Rogers",
            views: 6,
          },

          // {
          //   title: "Whispered Emotions",
          //   img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80", // Innovation
          //   author: "Claire Rogers",
          //   views: 187,
          // },
          // {
          //   title: "Golden Serenity",
          //   img: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80", // Devices
          //   author: "Claire Rogers",
          //   views: 60,
          // },
        ].map((item, i) => (
          <div className="col-md-6 mb-4" key={i}>
            <Card className="shadow-sm border-0 rounded-4">
              <Card.Img
                variant="top"
                src={item.img}
                style={{ height: "250px", objectFit: "cover" }}
              />
              <Card.Body>
                <h6 className="fw-bold">{item.title}</h6>
                <hr />
                <div className="d-flex justify-content-between align-items-center text-muted">
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src="/images/profile.svg"
                      alt="author"
                      className="mini-avatar"
                      style={{ width: "28px", height: "28px", borderRadius: "50%" }}
                    />
                    <span>{item.author}</span>
                  </div>
                  <div className="d-flex align-items-center gap-1">
                    <img src="/images/heart.svg" alt="views" width="20" />
                    <span className="text-muted">{item.views}</span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div> */}


      {/* <CompanyProfile /> */}

      <style>{`
        .profile-avatar {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 4px solid #17C653;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        .team-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }
        .mini-avatar {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          object-fit: cover;
        }
        .icon-inline {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        .section-icon {
          width: 32px;
          height: 32px;
          display: block;
        }
        .join-text {
          text-decoration: underline dotted;
        }
        .card {
          border-radius: 1rem !important;
        }
        .border-end {
          border-right: 1px solid #dee2e6;
        }
      `}</style>
    </div>
  );
};

export default Settings;
